function isAnalyticsAvailable() {
	if (typeof window === "undefined" || typeof window.gtag !== "function")
		return false;

	if (typeof navigator !== "undefined" && navigator.webdriver)
		return false;

	return true;
}

function trackEvent(eventName, eventParams = {}) {
	if (!isAnalyticsAvailable())
		return;

	try {
		window.gtag("event", eventName, eventParams);
	}
	catch (error) {
		console.error("Analytics event failed:", error);
	}
}

const CONTACT_FORM_SUBMIT_EVENT = "contact_form_submit";
const CONTACT_DIALOG_OPEN_EVENT = "contact_dialog_open";
const PROMO_VARIANT_VIEW_EVENT = "promo_variant_view";

const HOME_CONTACT_SOURCE_LABEL = "Home page";

let currentContactSource = null;

function setContactSource(contactSource) {
	currentContactSource = contactSource;
}

function clearContactSource() {
	currentContactSource = null;
}

function resolveContactFormLocation() {
	if (currentContactSource)
		return currentContactSource;

	return typeof window !== "undefined" ? window.location.pathname : undefined;
}

function formatContactSourceLabel(contactSourcePath) {
	if (typeof contactSourcePath !== "string")
		return HOME_CONTACT_SOURCE_LABEL;

	const cleanedPath = contactSourcePath
		.split("?")[0]
		.split("#")[0]
		.replace(/^\/+/, "")
		.replace(/\/+$/, "");

	if (cleanedPath === "")
		return HOME_CONTACT_SOURCE_LABEL;

	return cleanedPath
		.replace(/\//g, " ")
		.replace(/-/g, " ")
		.trim()
		.split(/\s+/)
		.filter(Boolean)
		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ");
}

function resolveContactSourceLabel() {
	return formatContactSourceLabel(resolveContactFormLocation());
}

function trackContactDialogOpened(extraParams = {}) {
	trackEvent(CONTACT_DIALOG_OPEN_EVENT, {
		form_location: resolveContactFormLocation(),
		...extraParams,
	});
}

function trackContactRequestSubmitted(extraParams = {}) {
	trackEvent(CONTACT_FORM_SUBMIT_EVENT, {
		form_location: resolveContactFormLocation(),
		...extraParams,
	});
}

function trackPromoVariantView(formLocation) {
	trackEvent(PROMO_VARIANT_VIEW_EVENT, {
		form_location: formLocation,
	});
}

export {
	trackEvent,
	trackContactDialogOpened,
	trackContactRequestSubmitted,
	trackPromoVariantView,
	setContactSource,
	clearContactSource,
	resolveContactSourceLabel,
	CONTACT_FORM_SUBMIT_EVENT,
	CONTACT_DIALOG_OPEN_EVENT,
	PROMO_VARIANT_VIEW_EVENT,
};